import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { Helmet } from 'react-helmet';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import { getErrorMessage } from '../utils/errorHandler';
import data from '../data/paomakeup';

const RegisterPage = () => {
  const { register: authRegister, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/mis-citas';

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertVariant, setAlertVariant] = useState('danger');
  const [showAlert, setShowAlert] = useState(false);

  const { register, handleSubmit, formState: { errors }, watch } = useForm();
  const password = watch('password');

  const registerOptions = {
    name: {
      required: 'El nombre es requerido',
      minLength: { value: 3, message: 'El nombre debe tener al menos 3 caracteres' },
    },
    email: {
      required: 'El email es requerido',
      pattern: {
        value: /^[A-z0-9._%+-]+@[A-z0-9.-]+\.[A-z]{2,4}$/,
        message: 'El email no es valido',
      },
    },
    phone: {
      required: 'El telefono es requerido',
      pattern: { value: /^[0-9]+$/, message: 'El telefono no es valido' },
    },
    password: {
      required: 'La contrasena es requerida',
      minLength: { value: 8, message: 'La contrasena debe tener al menos 8 caracteres' },
    },
    password_confirmation: {
      required: 'Debe confirmar la contrasena',
      validate: (value) => value === password || 'Las contrasenas no coinciden',
    },
  };

  const onSubmit = async (formData) => {
    try {
      setIsSubmitting(true);
      setShowAlert(false);
      await authRegister({
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        password: formData.password,
        password_confirmation: formData.password_confirmation,
        birthday_month: formData.birthday_month || undefined,
        birthday_day: formData.birthday_day || undefined,
      });
      navigate(from, { replace: true });
    } catch (err) {
      setAlertVariant('danger');
      setAlertMessage(getErrorMessage(err));
      setShowAlert(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container className="my-5">
      <Helmet>
        <title>Registro - {data.title}</title>
      </Helmet>
      <Row className="justify-content-center">
        <Col sm={8} md={6} lg={5}>
          <h1 className="mb-4 text-center">Crear Cuenta</h1>

          {showAlert && (
            <Alert variant={alertVariant} onClose={() => setShowAlert(false)} dismissible>
              {alertMessage}
            </Alert>
          )}

          {/* Google Sign-In */}
          {/* <div className="d-flex justify-content-center mb-3">
            <GoogleLogin
              onSuccess={(credentialResponse) => {
                setShowAlert(false);
                setIsSubmitting(true);
                loginWithGoogle(credentialResponse.credential)
                  .then(() => navigate(from, { replace: true }))
                  .catch((err) => {
                    setAlertVariant('danger');
                    setAlertMessage(getErrorMessage(err));
                    setShowAlert(true);
                  })
                  .finally(() => setIsSubmitting(false));
              }}
              onError={() => {
                setAlertMessage('Error al registrarse con Google. Intente de nuevo.');
                setAlertVariant('danger');
                setShowAlert(true);
              }}
              text="signup_with"
              width="100%"
            />
          </div> */}

          {/* <div className="d-flex align-items-center mb-3">
            <hr className="flex-grow-1" />
            <span className="px-3 text-muted small">o registrese con su correo</span>
            <hr className="flex-grow-1" />
          </div> */}

          <Form className="auth-form" onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="mb-3" controlId="registerName">
              <Form.Label>Nombre completo</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ingrese su nombre"
                {...register('name', registerOptions.name)}
              />
              <small className="text-danger">
                {errors?.name && errors.name.message}
              </small>
            </Form.Group>

            <Form.Group className="mb-3" controlId="registerEmail">
              <Form.Label>Correo electronico</Form.Label>
              <Form.Control
                type="email"
                placeholder="Ingrese su correo"
                {...register('email', registerOptions.email)}
              />
              <small className="text-danger">
                {errors?.email && errors.email.message}
              </small>
            </Form.Group>

            <Form.Group className="mb-3" controlId="registerPhone">
              <Form.Label>Telefono</Form.Label>
              <Form.Control
                type="tel"
                placeholder="Ingrese su telefono"
                {...register('phone', registerOptions.phone)}
              />
              <small className="text-danger">
                {errors?.phone && errors.phone.message}
              </small>
            </Form.Group>

            <Form.Group className="mb-3" controlId="registerPassword">
              <Form.Label>Contrasena</Form.Label>
              <Form.Control
                type="password"
                placeholder="Minimo 8 caracteres"
                {...register('password', registerOptions.password)}
              />
              <small className="text-danger">
                {errors?.password && errors.password.message}
              </small>
            </Form.Group>

            <Form.Group className="mb-3" controlId="registerPasswordConfirm">
              <Form.Label>Confirmar contrasena</Form.Label>
              <Form.Control
                type="password"
                placeholder="Repita su contrasena"
                {...register('password_confirmation', registerOptions.password_confirmation)}
              />
              <small className="text-danger">
                {errors?.password_confirmation && errors.password_confirmation.message}
              </small>
            </Form.Group>

            {/* Birthday selector */}
            <div className="mb-3 p-3 rounded-3" style={{ backgroundColor: '#FFF8FA', border: '1px solid #FCE4EC' }}>
              <Form.Label className="small mb-2" style={{ color: '#EF60A3' }}>
                Recibe ofertas increibles en tu dia de cumpleanos
              </Form.Label>
              <div className="d-flex gap-2">
                <Form.Select {...register('birthday_month')}>
                  <option value="">Mes</option>
                  {['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'].map((m, i) => (
                    <option key={i + 1} value={i + 1}>{m}</option>
                  ))}
                </Form.Select>
                <Form.Select {...register('birthday_day')}>
                  <option value="">Dia</option>
                  {Array.from({ length: 31 }, (_, i) => i + 1).map((d) => (
                    <option key={d} value={d}>{d}</option>
                  ))}
                </Form.Select>
              </div>
            </div>

            <div className="d-grid mb-3">
              <Button variant="primary" type="submit" disabled={isSubmitting}>
                {isSubmitting ? (
                  <span className="d-inline-flex align-items-center gap-2">
                    <Spinner animation="border" size="sm" /> Creando cuenta...
                  </span>
                ) : 'Crear Cuenta'}
              </Button>
            </div>

            <p className="text-center">
              ¿Ya tiene una cuenta?{' '}
              <Link to="/iniciar-sesion" className="text-decoration-none">
                Inicie sesion
              </Link>
            </p>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default RegisterPage;
